
import { Component, Vue } from 'vue-property-decorator'
import RegistMailAddress from '@/components/templates/activate/RegistMailAddress.vue'
import { TemporaryInformationsApi } from '@/api/methods/activate/TemporaryInformationsApi'
import { ApiBadRequestAppError } from '@/models/AppErrorClasses'

/**
 * 仮ユーザメールアドレス登録ページ
 */
@Component({
  components: {
    RegistMailAddress,
  },
})
export default class RegistInformation extends Vue {
  /**
   * メールアドレス登録時の処理
   *
   * @param mailAddress 登録メールアドレス
   */
  private async eventSubmit(mailAddress: string): Promise<void> {
    this.$loading.start()

    // メールアドレス登録処理
    try {
      await TemporaryInformationsApi.updateInformation(mailAddress)
    } catch (error) {
      if (error instanceof ApiBadRequestAppError) {
        alert('メールアドレスを正しく入力してください。')
        this.$loading.complete()
        return
      }

      // 400エラー以外の場合は例外を投げ直し、共通処理に渡す
      throw error
    }

    // 認証情報を削除して画面遷移
    this.$appCookies.removeAuth()

    this.$loading.complete()

    await this.$router.push('/activate/regist/complete')
  }
}
